module.exports = __webpack_public_path__ + "img/65.9.TU.b3b9378f.png";